module.exports = __webpack_public_path__ + "static/media/paid_en.37e7c491.svg";